const AdministrationTypes = {
  // ORGANIGRAMME
  GET_ORGANIGRAMME: "GET_ORGANIGRAMME",
  GET_ORGANIGRAMME_SUCCESS: "GET_ORGANIGRAMME_SUCCESS",
  POST_ORGANIGRAMME: "POST_ORGANIGRAMME_SUCCESS",
  POST_ORGANIGRAMME_SUCCESS: "POST_ORGANIGRAMME_SUCCESS",
  PATCH_ORGANIGRAMME: "PATCH_HOME_PAGE_CONFIG",
  PATCH_ORGANIGRAMME_SUCCESS: "PATCH_ORGANIGRAMME_SUCCESS",
  DELETE_ORGANIGRAMME: "DELETE_ORGANIGRAMME_SUCCESS",
  DELETE_ORGANIGRAMME_SUCCESS: "DELETE_ORGANIGRAMME_SUCCESS",
  // USERS
  GET_USERS: "GET_USERS",
  GET_USERS_SUCCESS: "GET_USERS_SUCCESS",
  POST_USERS: "POST_USERS",
  POST_USERS_SUCCESS: "POST_USERS_SUCCESS",
  PATCH_USERS: "PATCH_HOME_PAGE_CONFIG",
  PATCH_USERS_SUCCESS: "PATCH_USERS_SUCCESS",
  DELETE_USERS: "DELETE_USERS",
  DELETE_USERS_SUCCESS: "DELETE_USERS_SUCCESS",
  // PROFILS
  GET_PROFILS: "GET_PROFILS",
  GET_PROFILS_SUCCESS: "GET_PROFILS_SUCCESS",
  POST_PROFILS: "POST_PROFILS",
  POST_PROFILS_SUCCESS: "POST_PROFILS_SUCCESS",
  PATCH_PROFILS: "PATCH_HOME_PAGE_CONFIG",
  PATCH_PROFILS_SUCCESS: "PATCH_PROFILS_SUCCESS",
  DELETE_PROFILS: "DELETE_PROFILS_SUCCESS",
  DELETE_PROFILS_SUCCESS: "DELETE_PROFILS_SUCCESS",
}

export default AdministrationTypes
